<template>
  <v-dialog v-model="internal" width="300" height="200">
    <v-card data-testid="reset-password-modal" class="pb-5 d-flex align-center flex-column justify-center">
      <v-card-title>Reset Password?</v-card-title>
      <div>
        <v-text-field
          data-testid="management-password-input"
          dense
          class="my-2"
          type="password"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          autocomplete="new-password"
          v-model="newPassword"
          label="New Password"
        ></v-text-field>
      </div>
      <div class="d-flex flex-gap-2 justify-end">
        <v-btn
          @click="closeModal"
          :disabled="loadingDelete"
          color="primary"
          outlined
          >Cancel</v-btn
        >
        <v-btn
          data-testid="management-password-submit"
          @click="confirmReset"
          :disabled="loadingDelete || !hasPassword"
          :loading="loadingDelete"
          color="primary"
          >Confirm</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loadingDelete: {
      type: Boolean,
    },
  },
  data() {
    return {
      newPassword: null,
    };
  },
  emits: ["handle-delete"],
  watch: {
    value(v) {
      this.internal = v;
      this.newPassword = null;
    },
  },
  computed: {
    // A password is trimmed before it is hashed,
    // so a password of only spaces would be saved as an empty password.
    hasPassword() {
      return Boolean((this.newPassword || "").trim());
    },
    internal: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods: {
    confirmReset() {
      if (!this.hasPassword) return;
      this.$emit("handle-reset-password", this.newPassword);
    },
    closeModal() {
      this.newPassword = null;
      this.$emit("input", false);
    },
  },
};
</script>
